"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDatePlaceholder = exports.getLocalizedDateFormat = exports.getLocaleData = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

/**
 * Returns data for the current user's locale according to MomentJS. It's important that this not
 * be called until I18n is ready. For UIComponents, this means waiting until render.
 *
 * @return {Object}
 */
var getLocaleData = function getLocaleData() {
  var locale = (_I18n.default.moment.locale || _I18n.default.moment.lang)();

  return (_I18n.default.moment.localeData || _I18n.default.moment.langData)(locale);
};
/**
 * @param {("L"|"YYYY-MM-DD")} format
 * @return {string}
 */


exports.getLocaleData = getLocaleData;

var getLocalizedDateFormat = function getLocalizedDateFormat(format) {
  return getLocaleData()._longDateFormat[format] || format;
};
/**
 * @param {("L"|"YYYY-MM-DD")} format
 * @return {string}
 */


exports.getLocalizedDateFormat = getLocalizedDateFormat;

var getDatePlaceholder = function getDatePlaceholder(format) {
  return getLocalizedDateFormat(format).replace(/MM/, _I18n.default.text('ui.datePicker.placeholder.month')).replace(/DD/, _I18n.default.text('ui.datePicker.placeholder.day')).replace(/YYYY/, _I18n.default.text('ui.datePicker.placeholder.year'));
};

exports.getDatePlaceholder = getDatePlaceholder;